import product from "./product";

export default {
    product,

    noAvailableItems: "No hay productos disponibles para ordenar."
}